

import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeature,
  CharacterFeatureBase,
  EldritchInvocation,
} from "@dndModels";
import { DataType } from "@dndModels/Types";

export class CharacterEldritchInvocation extends CharacterFeatureSource {
  source: EldritchInvocation | null = null;

  get data_type(): DataType {
    return "eldritch_invocation";
  }
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (this.source_id === "" && obj.eldritch_invocation_id) {
        this.source_id = obj.eldritch_invocation_id;
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        const char_features: CharacterFeature[] = [];
        obj.features.forEach((o: any) => {
          char_features.push(new CharacterFeature(o));
        });
        const char_feature_base = new CharacterFeatureBase();
        char_feature_base.features = char_features;
        this.char_feature_bases.push(char_feature_base);
      }
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
    };
  }

  clone(drop_ids = false): CharacterEldritchInvocation {
    const clone = new CharacterEldritchInvocation();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterEldritchInvocation, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source?.clone()??null;
  }
}